<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="100000" />
    <van-skeleton
      :row="30"
      :loading="loading"
    >
      <div v-if="data" class="dataRect">
        <div class="line">商家: <span :style="'color:'+GetColorMainBack()">{{ data.systemName }}</span></div>
        <div class="line">订单号: <span :style="'color:'+GetColorMainBack()">{{ data.orderId }}</span></div>
        <div class="line">项目: <span :style="'color:'+GetColorMainBack()">{{ data.subject }}</span></div>
        <div class="line">预授权金额: <span :style="'color:'+GetColorMainBack()">CNY  {{ ShowMoney(data.amount) }}</span></div>
        <div class="line">订单状态: <span :style="'color:'+GetColorMainBack()">{{ GetEnumText('Em_AlipayFreezePayState',data.state) }}</span></div>
        <div class="line">备注: <span :style="'color:'+GetColorMainBack()">{{ data.orderRemark }}</span></div>
      </div>
      <div class="buttonRect">
        <van-button
          square
          type="danger"
          size="large"
          :color="GetColorMain()"
          style="width:100%"
          :loading="buttonLoading"
          loading-text="授权中..."
          :v-if="data.state==='CREATE' || data.state==='VISIT'"
          @click="onSubmit"
        >授权</van-button>
      </div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '预授权订单',
      backurl: '/store/index',
      hashCode: undefined,
      data: undefined,
      loading: true,
      buttonLoading: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.hashCode = this.$route.params.code
    this.init()
    window.my.onMessage = function(e) {
      switch (e.type) {
        case 'onfreezePay':
          if (e.success) {
            setTimeout(() => {
              this.init()
            }, 100)
            setTimeout(() => {
              this.init()
            }, 5000)
          } else {
            MyNotify('info', '取消预授权')
          }
          break
        default:
          window.my.alert({
            content: e.type
          })
      }
    }
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      request({
        url: '/alipay/getAlipayFreezeUserBill',
        method: 'post',
        params: {
          id: this.hashCode
        }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    },
    onSubmit() {
      window.my.postMessage({ 'type': 'freezePay', 'payStr': this.data.payStr })
    }
  }
}
</script>
<style scoped>
.dataRect{
    background-color: #fff;
    padding: 1em;
    margin: 1em;
    border-radius: 0.4em;
    font-size: 0.8em;
}
.dataRect .line{
    padding: 0.5em 0;
}
.dataRect .line span{

}
.buttonRect{

}
</style>
